function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useEffect, useRef } from 'react';
import styles from './Tab.module.scss';
import I18n from '../../I18n/I18n/I18n';
import { TabContext } from '../Tabs';
import KEYCODES from '../../utils/KEYCODES';
import cs from 'classnames';
import ThemeContext from '../../ThemeContext/ThemeContext';
export default function Tab(_ref) {
  var className = _ref.className,
    id = _ref.id,
    i18n = _ref.i18n,
    _ref$scrollableTab = _ref.scrollableTab,
    scrollableTab = _ref$scrollableTab === void 0 ? false : _ref$scrollableTab;
  var theme = useContext(ThemeContext);
  var _useContext = useContext(TabContext),
    selected = _useContext.selected,
    dispatch = _useContext.dispatch;
  var isSelected = id === selected;
  var ref = useRef(null);
  var updateRef = useRef(false);
  function handleClick(e) {
    e.preventDefault();
    dispatch({
      type: 'select:tab',
      payload: id
    });
  }
  function handleKeydown(e) {
    switch (e.which) {
      case KEYCODES.LEFT_ARROW:
        e.preventDefault();
        dispatch({
          type: 'select-prev:tab',
          payload: id
        });
        break;
      case KEYCODES.RIGHT_ARROW:
        e.preventDefault();
        dispatch({
          type: 'select-next:tab',
          payload: id
        });
        break;
      case KEYCODES.DOWN_ARROW:
        e.preventDefault();
        var panel = document.getElementById(id);
        panel && panel.focus();
        break;
    }
  }
  useEffect(function () {
    if (updateRef.current) {
      var current = ref.current;
      if (isSelected && current && document.activeElement !== current) {
        current.focus();
      }
    } else {
      updateRef.current = true;
    }
  }, [isSelected]);
  return /*#__PURE__*/React.createElement("li", {
    role: "presentation",
    className: cs(styles.item, "".concat(styles[theme]), _defineProperty({}, className, className))
  }, /*#__PURE__*/React.createElement("a", {
    ref: ref,
    role: "tab",
    href: "#".concat(id),
    id: "".concat(id, "-tab"),
    className: cs(styles.anchor, _defineProperty({}, styles.anchorNoWrap, scrollableTab)),
    "aria-selected": isSelected,
    onClick: handleClick,
    onKeyDown: handleKeydown,
    tabIndex: isSelected ? 0 : -1
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })));
}